import { createChildListViewComponent } from 'factories/ChildListView'
import entityNames from 'options/entityNames'
import { tryParseMoment, ZERO_HOUR } from 'helpers/dateTime'
import { t } from 'helpers/i18n'
import FormView from 'containers/Jobs/Labour/FormView'

export default createChildListViewComponent({
  entityName: entityNames.jobs,
  childName: 'jobLabour',
  createButtonTextId: 'addLabour',
  createButtonLinkTarget: {
    formSize: 'xs',
    formComponent: FormView,
  },
  primaryLinkTarget: 'labourRecord',
  allowCustomize: (self) => true,
  tableCellComponents: {
    timeSpan: (self, item) => {
      if (item.timeType === 'StartStop') {
        const startMoment = tryParseMoment(item.startTime, ZERO_HOUR).year(2000).month(1).date(1)
        const stopMoment = tryParseMoment(item.stopTime, ZERO_HOUR).year(2000).month(1).date(1)

        return `${startMoment.format('h:mm A')} To ${stopMoment.format('h:mm A')}`
      }

      return t('na')
    },
  },
})()
